import { QueryClient, MutationCache } from '@tanstack/react-query';
import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import { del, get, set } from 'idb-keyval';
import { toast } from '@dezza/ui';
import { ApiError, errorMessage } from './api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 1000 * 60 * 60 * 24,
      refetchOnWindowFocus: true,
      retry: (count, err) => {
        if (err instanceof ApiError && err.status > 0 && err.status < 500) return false;
        return count < 2;
      },
    },
    mutations: { retry: false },
  },
  mutationCache: new MutationCache({
    onError: (err, _vars, _ctx, mutation) => {
      // Mutations podem tratar o erro sozinhas marcando meta.silent.
      if (mutation.meta?.silent) return;
      if (err instanceof ApiError && (err.code === 'FEATURE_NOT_AVAILABLE' || err.code === 'LIMIT_REACHED' || err.code === 'UNAUTHENTICATED')) return;
      toast.error(errorMessage(err));
    },
  }),
});

/**
 * Persistência do cache no IndexedDB: só as consultas marcadas com
 * meta.persist (catálogo do PDV, categorias, clientes recentes) — é o que
 * permite abrir o PDV e vender sem internet.
 */
export const persister = createAsyncStoragePersister({
  storage: { getItem: (k) => get(k), setItem: (k, v) => set(k, v), removeItem: (k) => del(k) },
  key: 'dz.query-cache',
  throttleTime: 2_000,
});

export const PERSIST_MAX_AGE = 1000 * 60 * 60 * 24 * 7;

declare module '@tanstack/react-query' {
  interface Register {
    queryMeta: { persist?: boolean };
    mutationMeta: { silent?: boolean };
  }
}
